import { useAtomValue } from 'jotai';
import { unwrappedSelectedPlayerNameAtom } from '@/atoms/player/info';
import { unwrappedPlayerComparisonNameAtom } from '@/atoms/queries/player/playerComparisonRadar';
import { EntityMetricPreview } from '@/components/preview/EntityMetricPreview';
import { COMPARISON_ID } from '@/consts/searchKeys';
import { useQueryParam } from '@/hooks/useQueryParam';
import { PlayerComparisonPreviewPanel } from './PlayerComparisonPreviewPanel';
import { PlayerPrimaryPreviewPanel } from './PlayerPrimaryPreviewPanel';

export const PlayerPreview = () => {
  const comparisonId = useQueryParam(COMPARISON_ID);
  const primaryLabel = useAtomValue(unwrappedSelectedPlayerNameAtom);
  const comparisonLabel = useAtomValue(unwrappedPlayerComparisonNameAtom);

  return (
    <EntityMetricPreview
      entity="player"
      primaryLabel={primaryLabel ?? ''}
      comparisonLabel={comparisonLabel ?? ''}
      primaryPanel={<PlayerPrimaryPreviewPanel />}
      comparisonPanel={comparisonId ? <PlayerComparisonPreviewPanel /> : undefined}
    />
  );
};

export default PlayerPreview;
